

/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'
/* global _gaq */

expocadfx.util = {

    checkDate: function( config) {
        var testDate = new Date( config.year, config.month, config.day);
        return( Math.round( (Date.now() - testDate.getTime())/ (1000*60*60*24) ));	// mSec per day
    },
    
    checkFile: function ( config, domain) {
        var result = false;
        var x11 = config.year + (100 * config.day) + config.month;
        var x12 = config.year + (100 * config.month) + config.day;

        x12 = Math.floor( ( x11 + (10 * x12)) / 2);

        if( config.checkSum === x12 * 3 + config.fileNumber) {
            result = true;		// valid normal version
        }
        else if( config.checkSum === x12 * 4 + config.fileNumber ) {
            if( domain === "www.expocad.com" || domain === "www.expocadondemand.com") {
                result = true;		// valid free verson - IF running on 'www.expocad.com/host/
            }
        }
        return result;
    },
    
	updateMinMax: function( obj, x, y) {
		obj.minX = ( x < obj.minX) ? x : obj.minX;
        obj.maxX = ( x > obj.maxX) ? x : obj.maxX;
        obj.minY = ( y < obj.minY) ? y : obj.minY;
        obj.maxY = ( y > obj.maxY) ? y : obj.maxY;
	},
    
    findBoothIndex: function( bthNum, booths) {
        var i = 0;
        var len = booths.length;
        
        for( i = 0; i < len; i++) {
            if( booths[i].number === bthNum) {
                return i;
            }
        }
        return -1;
    },
    
    findBoothObject: function( bthNum, booths) {
        var i = 0;
        var len = booths.length;
        
        for( i = 0; i < len; i++) {
            if( booths[i].number === bthNum) {
                return booths[i];
            }
        }
        return null;
    },
    
//    findExhibitor: function( id, exhibitors) {
//        var i = 0;
//        var len = exhibitors.length;
//        for( i = 0; i < len; i++) {
//            if( exhibitors[i].exhId === id) {
//                return i;
//            }
//        }
//        return -1;
//    },
	
	arrayFind: function( arr, key, value) {		// returns obj if found
		var len = arr.length;
		var i = 0;
		for ( i = 0; i < len; i++) {
			if (arr[i][key] === value) {
				return arr[i];
			}
		}
		return null;
	},
    
        // This function should go away. It corrects color codes from FX Plus and allow 3 digit colors
    fixColor: function( color) {
        color = color.replace( "0x", "#");
        if( color.length > 7) {
            color = color.toUpperCase();
            color = color.replace( "#FF", "#");     // fix Andy's 8 digit hex numbers
        }
        if( color.length === 4) {       //  convert 3 digit hex to 6 digit
            color = color.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
                return "#" + r + r + g + g + b + b;
            }); 
        }
        return color;
    },
    
    makeGradientStyle: function( c1, c2, rot) {
        var gradient = "linear-gradient(";
        if( rot && rot !== "") {
            gradient += rot + "deg,";
        }
        gradient += c1 + ", " + c2 + ")";
        return gradient;
    },
    

    textFromXML: function( xml, color, fontFamily) {
        var size = xml.getAttribute("s");
        var font = size + "px " + fontFamily;
            // angle saved in radians for browser and degrees for pdf output
        var txt = {
            x: parseInt(xml.getAttribute("x"), 10),
            y: parseInt(xml.getAttribute("y"), 10),
			dRot: parseInt(xml.getAttribute("r"), 10),
            rotation: parseInt(xml.getAttribute("r"), 10)*Math.PI/180,
            text: xml.getAttribute("v"),
            fontSize: size,
            font: font,
            fill: color,
			isDimension: xml.getAttribute("t") === "1"
        };
        return txt;
    },
    textFromJSON: function( jsonObject, color, fontFamily) {
        var size = jsonObject.size;
        //var size = 8;
        var font = size + "px " + fontFamily;
            // angle saved in radians for browser and degrees for pdf output
        var txt = {
            x: parseInt(jsonObject.X, 10),
            //x: parseInt(jsonObject.geometry[0].textStartPoint.x, 10),
            y: parseInt(jsonObject.Y, 10),
            //y: parseInt(8850 - (jsonObject.geometry[0].textStartPoint.y, 10)),
            //dRot: parseInt(jsonObject.rotation, 10),
            //dRot: jsonObject.rotationRadians,
            dRot: parseFloat(jsonObject.rotationRads), //0,
            // rotation: parseInt(jsonObject.rotation, 10)*Math.PI/180,
            rotation: parseFloat(jsonObject.rotationRads), // 0,
            text: jsonObject.text,
            //text: jsonObject.boothNumber,
            fontSize: size,
            font: font,
            fill: color,
            // isDimension: jsonObject.isDimension === "1"
            isDim: jsonObject.isDim
        };
        return txt;
    },
    
    drawText: function( context, txtObj) {
        var locX = txtObj.x;
        var locY = txtObj.y;
        
        context.save();
        context.font = txtObj.font;
        context.fillStyle = txtObj.fill;
        context.textBaseline = "bottom";
        if( txtObj.rotation !== 0) {
            context.translate( locX, locY);
            context.rotate( txtObj.rotation);
            context.translate( -locX, -locY);
            context.fillText( txtObj.text, locX, locY + 0.5 * txtObj.fontSize);
            
        }
        else {
            context.fillText( txtObj.text, locX, locY + txtObj.fontSize/2);
        }
        context.restore();
    },
    
    gaSetup: function( account) {
        if( account !== "UA-xxxxxxxx-x") {
            window._gaq = window._gaq || [];
            _gaq.push(['_setAccount', account]);
            _gaq.push(['_trackPageview']);
            
            (function() {
                var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
                ga.src = ('https:' === document.location.protocol ? 'https://ssl' : 'http://www') + 
                    '.google-analytics.com/ga.js';
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
            }());
        }
    },
    
    parseQuerySting : function( config, data) {
        var q = location.search.substr(1).split("&");
        var tmp;
        var i;
        for( i = 0; i < q.length; i++) {
            tmp = q[i].split("=");
            if( tmp[0] === "event") {
                data.queryEvent = tmp[1];
            }
            else if( tmp[0] === "IAH") {
                data.queryCoord = tmp[1];     // comma separated point - x, y
            }
            else if( tmp[0] === "units") {
                config.units = tmp[1];
            }
            else if( tmp[0] === "zoomto") {
                data.queryBooths = decodeURIComponent( tmp[1]);    // comma separatated booth numbers
            }
            else if( tmp[0] === "data") {
                data.queryIndex = decodeURIComponent( tmp[1]);    // comma separatated booth indice
            }
            else if( tmp[0] === "auth") {
                data.queryAuthKey = tmp[1];
            }
            else if( tmp[0] === "exh") {
                data.queryExhibitor = unescape(tmp[1]);   // NEW - passed if click on exhibitor name in exhibitor list
            }
            else if( tmp[0] === "mode") {
                if( tmp[1] === "sales" || tmp[1] === "exhibitor" || tmp[1] === "contra") {
                    config.salesMode = tmp[1];
                    config.noNav = true;
                }
                else {
                    config.salesMode = "none";
                }
            }
            else if( tmp[0] === "coords" && this.isTrue(tmp[1])) {
                config.showCoords = true;
            }
            else if( tmp[0] === "msg") {		//   ?? Not used !
                data.queryMessage = decodeURI( tmp[1]);
            }
            else if(tmp[0] === "rpt") {
                
                if(tmp[1].trim() !== "") {
                    data.queryActCode = tmp[1];
                }
            }   
            else if( tmp[0] === "view") {		//   ?? Not used !
                config.apiView = decodeURI( tmp[1]);
            }
            else if( tmp[0] === "options"){
                config.optionsSet = tmp[1];
            }
            else if( tmp[0] === "nonav" ){ 
                config.noNav = true;
                //var dirNavBar = document.getElementById("directoryNav");
                //dirNavBar.remove();
            }
        }
    },
    
    parseUA : function( ua, data) {
        var index = 0;
        var temp = "";
        data.device = "other";
        
        if( ua.indexOf( "iPhone") > -1 || ua.indexOf( "iPad") > -1 || ua.indexOf( "iPod") > -1) {
            data.device = "ios";
            index = ua.indexOf( "Version/");
            if( index > -1) {
                temp = ua.slice( index + 8);
                index = temp.indexOf( " ");
                temp = temp.slice( 0, index);
                data.notOldios = parseFloat( temp) >= 8;
            }
        }
        if( ua.indexOf( "Android") > -1) {
            data.device = "A";
        }
		
		data.firefox = navigator.userAgent.indexOf( "Firefox") !== -1;
		data.msie = navigator.userAgent.indexOf( "Trident") !== -1 ||
					navigator.userAgent.indexOf( "Edge") !== -1;
    },
    
	hasClass : function( e, c) {
		var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
		return re.test(e.className);
	},

	addClass : function( e, c) {
		if ( this.hasClass(e, c) ) {
			return;
		}
		var newclass = e.className.split(' ');
		newclass.push(c);
		e.className = newclass.join(' ');
	},

	removeClass : function ( e, c) {
        var arClass = e.className.split( " ");
        var index = arClass.indexOf( c);
        if( index !== -1) {
            arClass.splice( index, 1);
            e.className = arClass.join( " ");
        }
	},
    
    toggleClass : function( e, c) {
        if ( this.hasClass(e, c) ) {
			this.removeClass( e, c);
			return false;
		}
        else {
            this.addClass( e, c);
			return true;
        }
    },
    
    isTrue: function( value) {
        return ( value && ( value.toLowerCase() === "t" || value.toLowerCase() === "true"));
    },
	
    detectWebGL: function() {
        var canvas = document.createElement( "canvas");
        try {
            if( canvas.getContext( "webgl") || canvas.getContext( "experimental-webgl")) {
               return true;
            }
            console.log( "DID NOT GET A webGL CANVSA DRAWING CONTEXT");
            return false;
        }
        catch( ex) {
			console.log( "  detect webGL exception: " + ex.message);
            return false;
        }
    },
	
    navigateTo: function( url, name) {
        if (name){
            window.open(url, name);
        }
        
        var newWin = window.open();
		newWin.opener = null;
        if( url.substr( 0, 4) !== "http") {
            url = "http://" + url;
        }
        newWin.location = url;
    },

    ajaxCall: function(url, mthd, data, callback) {
        $.ajax({
            url: url,
            contentType: "text/plain; charset=utf-8",
            processData: false,
            method: mthd,
            data: data,
            dataType: "text",
            complete: function (dat) {
                if (callback != null) {
                    callback(dat.responseText);
                }
            },
            error: function () {
                // TO DO Add some error handling and logging
                console.log("uh oh");
            }
        });
    }

};